import HubertInput from 'components/HubertUI/HubertInput';
import HubertLabel from 'components/HubertUI/HubertLabel';
import MutedText from 'components/common/MutedText';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'rtk/query/hooks';
import { selectQuestionClassificationNames } from 'rtk/questionEditorSelector';
import { useQuestionEditorContext } from '../context/create-question.context';

const ClassificationInfo = () => {
  const { t } = useTranslation('Questionsv2');
  const { questionId } = useQuestionEditorContext();
  const classification = useAppSelector((state) => selectQuestionClassificationNames(state, questionId));

  if (!classification) return null;

  return (
    <div className="flex flex-col justify-start gap-4 p-1">
      <div className="hubert-vertical-center flex flex-row justify-start gap-4">
        <HubertLabel htmlFor="question-category">{t('classification.type')}</HubertLabel>
        <HubertInput id="question-category" disabled value={classification.type} />
      </div>
      <div className="hubert-vertical-center flex flex-row justify-start gap-4">
        <HubertLabel htmlFor="question-topics">{t('classification.topics')}</HubertLabel>
        <HubertInput
          id="question-topics"
          disabled
          value={classification.topics.join(', ')}
          placeholder={t('classification.none')}
        />
      </div>
      <MutedText text={t('classification.hint')} />
    </div>
  );
};

export default ClassificationInfo;
